// Where-clause fragments shared by both query paths' filter builders (useCurbsuiteTransactionsData
// and useBusStationTransactionsData) -- the underlying GridFilterModel items for these columns are
// interpreted identically regardless of which query answers them.

export function transactionIndexFilter(value: unknown): Record<string, unknown> {
  return { transaction: { index: { _eq: value } } };
}

export function dateOperatorFilter(
  graphQLField: string,
  operatorValue: string | undefined,
  value: string,
): Record<string, unknown> | undefined {
  switch (operatorValue) {
    case "is":
      return { [graphQLField]: { _eq: value } };
    case "before":
      return { [graphQLField]: { _lt: value } };
    case "after":
      return { [graphQLField]: { _gt: value } };
    default:
      return undefined;
  }
}

export function licensePlateFilter(operatorValue: string | undefined, value: string): Record<string, unknown> {
  return operatorValue === "contains"
    ? { transaction: { registered_vehicle: { license_plate: { _ilike: `%${value.toUpperCase()}%` } } } }
    : { transaction: { registered_vehicle: { license_plate: { _eq: value.toUpperCase() } } } };
}

export function operatorNameFilter(value: string): Record<string, unknown> {
  return { payer_account: { organization_name: { _ilike: `%${value}%` } } };
}
